import { useEffect } from 'react'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'

export const MouseflowDataPush = () => {
  const gaDataPush = (data: any) => {
    DigitalData.pushSimpleEvent(data)
  }

  useEffect(() => {
    gaDataPush('mouseflowTestToggle')
  }, [])

  return null
}
